import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export default class PlatformGpLoginApiService {
	private static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/gp/login`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async notifyCloseWebsite() {
		const context = getApiRequestContext();
		return httpClient.post(
			`${this.baseUrl}/browser-close`,
			null,
			this.getRequestHeaders(context),
			{
				keepalive: true,
			}
		);
	}

	static async deactivateUser(
		isTimeoutLogout: boolean = false,
		options: ContextOptions
	): Promise<void> {
		const context = getApiRequestContext(options);
		const headers: HeadersInit = this.getRequestHeaders(context);

		return await httpClient.delete(
			`${WEBPACK_BASE_ADDRESS}platform/gp/login/deactivate?isTimeout=${isTimeoutLogout}`,
			headers
		);
	}
}
